/**
 * 信息流菜单
 * @author lianghua.fu
 * @date 2020-09-16 19:16:48
 */

import { debug, request, user } from 'lib';
import { UiToast } from 'components';

import get from 'lodash/get';

import { globalStore } from 'stores';
import auth from './auth';
import room from './room';
import Menu from '../ui/menu';

/**
 * 显示菜单
 * @param {number} userId
 */
const show = async (userId, opts = {}) => {
  const { isLogin, userInfo } = globalStore;

  let { isOpenMystic } = opts;
  if (!isLogin) {
    return;
  }
  // 自己不显示菜单
  if (userInfo._id === userId) {
    return;
  }

  const _show = (menuUserInfo) => {
    let items = [
      !isOpenMystic
        ? {
            key: 'imChat',
            text: '私聊TA',
          }
        : false,
      ...getForbidMenuItems(),
      // ...getKickMenuItems(),
    ].filter((item) => {
      return !!item;
    });
    items = event.onBeforeShow(userId, items, menuUserInfo);

    debug.log('auth menu items=>', items);

    Menu.show({
      items,
      className: 'sm',
      onSelectItem: (key, subKey) => {
        debug.log('onSelectItem', userId, key, subKey);

        event.onSelectItem(userId, key, subKey, menuUserInfo);

        if (key.indexOf('party-') !== -1) {
          const action = key.split('-')[1];
          auth.handleHostOperator(action, userId);
        }

        auth[key] && auth[key](userId, subKey, menuUserInfo);
      },
    });
  };

  // try {
  const { data: menuUserInfo } = await request.api.get(`zone/user_info/${userId}`);

  if (!room.isHost() && room.isMicStar(globalStore.userId)) {
    const { data: taskInfo } = await request.cryolite.get('/api/v5/star-notify/user-task-info', {
      uid: userId,
    });
    menuUserInfo.taskInfo = taskInfo;
  } else {
    menuUserInfo.taskInfo = {};
  }

  // 临时兜底
  if (isOpenMystic) {
    _show(menuUserInfo);
  } else {
    isOpenMystic = isOpenMystic || get(menuUserInfo, 'mystic.open');
    _show(menuUserInfo);
  }

  // } catch (e){
  //   UiToast.fail('用户信息错误');
  // }
};

const getForbidMenuItems = () => {
  if (room.getRoomType() === 6) {
    return [
      {
        key: 'party-shutup',
        text: '禁言',
      },
      {
        key: 'party-block',
        text: '拉黑',
      },
      {
        key: 'party-kick',
        text: '踢人',
      },
    ];
  }
  return [
    {
      key: 'forbid',
      text: '禁言',
      children: [
        { key: 5, text: '5分钟' },
        { key: 10, text: '10分钟' },
      ],
    },
    { text: '恢复禁言', key: 'cancelForbid' },
  ];
};

const getKickMenuItems = () => {
  return [
    {
      key: 'kickOut',
      text: '踢出房间',
      children: [
        { key: 5, text: '5分钟' },
        { key: 10, text: '10分钟' },
      ],
    },
  ];
};

const getMicUserMenuItems = (menuUserInfo) => {
  const menus = [];
  if (!room.isHost() && room.isMicStar(globalStore.userId)) {
    menus.push({
      key: 'redirectArchive',
      text: '看TA的档案',
    });

    if (menuUserInfo.taskInfo.new_user_task) {
      menus.push({
        key: 'notifyNewUserTask',
        text: '提示新人任务',
      });
    }

    if (menuUserInfo.taskInfo.new_user_first_gift) {
      menus.push({
        key: 'notifyNewUserFirstGift',
        text: '提示首充礼包',
      });
    }
    menus.push({
      key: 'pokeAgain',
      text: '戳一戳TA',
    });
  }
  return menus;
};

const event = {
  onBeforeShow: (userId, menus, menuUserInfo) => {
    return menus;
  },
  onSelectItem: (userId, key, subKey, menuUserInfo) => {},
};

export default {
  show,
  event,
  getMicUserMenuItems,
};
